import React, { Component } from 'react';
import { Modal, Steps, Button, message, Select } from 'antd';
const Step = Steps.Step;
const Option = Select.Option;

class ProfileModal extends Component {
  constructor(props) {
    super(props);
    this.steps = {step0: {names: false, clave: true, email: true}, step1: {branch_id: false, department_id: false}, step2: {job_id: false, rol_id: false}, step3: {global: true, username: false, password: false}};
    this.state = {step: 0, stepLimit: 3, stepValidation: this.steps, profile: {}};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handleNames = this.handleNames.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
    this.handleClave = this.handleClave.bind(this);
    this.handleBranch = this.handleBranch.bind(this);
    this.handleDepartment = this.handleDepartment.bind(this);
    this.handleJob = this.handleJob.bind(this);
    this.handleRol = this.handleRol.bind(this);
    this.handleGlobal = this.handleGlobal.bind(this);
    this.handleUsername = this.handleUsername.bind(this);
    this.handlePassword = this.handlePassword.bind(this);
    this.setProp = this.setProp.bind(this);
  }

  handleNext() {
    if(!this.validateStep())
      return message.warning('Necesitas llenar todos los campos obligatorios');

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.profile);
      this.setState({profile: {}, step: 0});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  validateStep() {
    let steps = 0;
    let total = 0;
    for(let item in this.state.stepValidation[`step${this.state.step}`]) {
      if(this.state.stepValidation[`step${this.state.step}`][item]) {
        steps += 1;
      }
      total += 1;
    }
    
    if(steps === total) {
      return true;
    } else {
      return false;
    }
  }

  handleNames(event) {
    this.setProp('names', event.target.value);
  }

  handleEmail(event) {
    this.setProp('email', event.target.value);
  }

  handleClave(event) {
    this.setProp('clave', event.target.value);
  }

  handleDepartment(value) {
    this.setProp('department_id', value);
  }

  handleBranch(value) {
    this.setProp('branch_id', value);
  }

  handleJob(value) {
    this.setProp('job_id', value);
  }

  handleRol(value) {
    this.setProp('rol_id', value);
  }

  handleGlobal(value) {
    this.setProp('global', value);
  }

  handleUsername(event) {
    this.setProp('username', event.target.value);
  }

  handlePassword(event) {
    this.setProp('password', event.target.value);
  }

  setProp(prop, value) {
    let profile = this.state.profile;
    let validation = this.state.stepValidation;
    profile[prop] = value;
    
    // Update validation
    if(String(value).length > 0) {
      validation[`step${this.state.step}`][prop] = true;
    } else {
      validation[`step${this.state.step}`][prop] = false;
    }

    this.setState({profile: profile, stepValidation: validation});
  }

  showStep(step) {
    if(this.state.step === step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // List branches
    const branches = this.props.branches.map(branch => {
      return (
        <Option key={branch.id} value={branch.id}>{branch.name}</Option>
      );
    });

    // List departments
    const departments = this.props.departments.map(department => {
      return (
        <Option key={department.id} value={department.id}>{department.name}</Option>
      );
    });

    // List jobs
    const jobs = this.props.jobs.map(job => {
      return (
        <Option key={job.id} value={job.id}>{job.name}</Option>
      );
    });

    // List rols
    const rols = this.props.rols.map(rol => {
      return (
        <Option key={rol.id} value={rol.id}>{rol.name}</Option>
      );
    });

    // Render component
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Generales" />
            <Step title="Departamento" />
            <Step title="Rol" />
            <Step title="Credenciales" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          {/* Step 1 */}
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Nombres</label>
              <input type="text" className="form-control" defaultValue={this.props.current.names} placeholder="Nombre completo" onChange={this.handleNames} />
            </div>

            <div className="form-group">
              <label>Email (Opcional)</label>
              <input type="text" className="form-control" defaultValue={this.props.current.email} placeholder="email@empresa.com" onChange={this.handleEmail} />
            </div>

            <div className="form-group">
              <label>Clave de empleado (Opcional)</label>
              <input type="text" className="form-control" defaultValue={this.props.current.clave} placeholder="001" onChange={this.handleClave} />
            </div>
          </div>

          {/* Step 2 */}
          <div style={{ width: '100%', display: this.showStep(1) }}>
            <div className="form-group">
              <label>Sucursal</label>
              <Select
                showSearch
                onChange={this.handleBranch}
                optionFilterProp="children"
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                style={{ width: '100%' }}
              >
                {branches}
              </Select>
            </div>

            <div className="form-group">
              <label>Departamento</label>
              <Select
                showSearch
                onChange={this.handleDepartment}
                optionFilterProp="children"
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                style={{ width: '100%' }}
              >
                {departments}
              </Select>
            </div>
          </div>

          {/* Step 3 */}
          <div style={{ width: '100%', display: this.showStep(2) }}>
            <div className="form-group">
              <label>Puesto</label>
              <Select
                showSearch
                onChange={this.handleJob}
                optionFilterProp="children"
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                style={{ width: '100%' }}
              >
                {jobs}
              </Select>
            </div>

            <div className="form-group">
              <label>Rol</label>
              <Select
                showSearch
                onChange={this.handleRol}
                optionFilterProp="children"
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                style={{ width: '100%' }}
              >
                {rols}
              </Select>
            </div>
          </div>

          {/* Step 4 */}
          <div style={{ width: '100%', display: this.showStep(3) }}>
            <div className="form-group">
              <label>¿Es un usuario global?</label>
              <Select style={{ width: '100%' }} onChange={this.handleGlobal}>
                <Option value={'true'}>Si</Option>
                <Option value={'false'}>No</Option>
              </Select>
            </div>

            <div className="form-group">
              <label>Usuario</label>
              <input type="text" className="form-control" defaultValue={this.props.current.username} onChange={this.handleUsername} />
            </div>

            <div className="form-group">
              <label>Contraseña</label>
              <input type="text" className="form-control" defaultValue={this.props.current.password} onChange={this.handlePassword} />
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default ProfileModal;



// WEBPACK FOOTER //
// ./src/components/modals/ProfileModal.js